import { render } from "./FoodView.vue?vue&type=template&id=978710a4"
import script from "./FoodView.vue?vue&type=script&lang=js"
export * from "./FoodView.vue?vue&type=script&lang=js"

import "./FoodView.vue?vue&type=style&index=0&id=978710a4&lang=scss"
import "./FoodView.vue?vue&type=style&index=1&id=978710a4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__